import Vue from "vue";
import Vuex from "vuex";
import UserModule from "./modules/UserModule";
import GenderModule from "./modules/GenderModule";
import AgeRatingModule from "./modules/AgeRatingModule";

Vue.use(Vuex);

export default new Vuex.Store({
    state:{},
    getters:{},
    mutations:{},
    actions:{},
    modules:{
        UserModule,
        GenderModule,
        AgeRatingModule,
    }
})